import React from 'react';
import { useNavigate } from 'react-router-dom';
import CountrySelector from './CountrySelector';

export default function PageHeader({ title, backTo, backLabel = '← Back', showCountry = true }) {
  const navigate = useNavigate();
  
  return (
    <div className="page-header">
      {backTo ? (
        <button className="back-btn" onClick={() => navigate(backTo)}>
          {backLabel}
        </button>
      ) : (
        <span style={{ width: 60 }} />
      )}
      <h1 className="page-title">{title}</h1>
      {showCountry ? <CountrySelector /> : <span style={{ width: 60 }} />}
    </div>
  );
}
